"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SIZE_TAG_MAP = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var textStyles = _interopRequireWildcard(require("../../../helpers/text"));
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
var _tokens = require("../../../tokens");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const SIZE_TAG_MAP = exports.SIZE_TAG_MAP = {
  XL: 'h1',
  L: 'h2',
  M: 'h3',
  S: 'h4',
  XS: 'h5'
};
const StyledH = (0, _styledComponents.default)(_ref => {
  let {
    tag,
    size,
    ...props
  } = _ref;
  const elementSize = size ? SIZE_TAG_MAP[size] : undefined;
  const element = tag || elementSize || 'h6';
  return /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
    omitProps: {
      keys: ['decorative', 'context', 'color']
    },
    tag: element,
    bumpSpecificity: true
  }, props));
}).withConfig({
  displayName: "StyledH",
  componentId: "sc-1oky7xj-0"
})(["", " ", " ", ""], _ref2 => {
  let {
    size,
    context
  } = _ref2;
  return context ? (0, _styledComponents.css)(["", ";color:", ";"], textStyles.smallCaps, _tokens.COLOR.GREY.DARK) : textStyles[`heading${size || 'XS'}`];
}, _ref3 => {
  let {
    decorative
  } = _ref3;
  return decorative && `
    font-family: ${_tokens.FONT.FAMILY.DECORATIVE};
    font-weight: ${_tokens.FONT.WEIGHT.REGULAR};
  `;
}, _ref4 => {
  let {
    color
  } = _ref4;
  return color && `color: ${color};`;
});

/**
## Usage

```jsx
import { H } from '@farewill/ui'
```

## Notes

`<H>`s extend `<Wrapper>` so can use any of `<Wrapper>`’s styling functionality, notably the `margin` and `centered` properties.

If the `tag` prop isn't specified the `size` prop is used to determine which element to use (`XL: <h1>`, `L: <h2>` etc.).

### How to use headings

Visuelt is our main typeface, used across both the product and marketing pages

Heading sizes are not tied to HTML markup H1, H2, H3 etc. Style headings visually to create a clear, balanced heirarchy. Always use the correct heading markup and structure (H1 followed by H2, and so on).

Heading L should only be used once on the page - usually at the top. M, S and XS can then be used for sub-headings. We also use XS in places where space is an issue, such as headings in modals, or for side panels, such as ‘Questions?’

#### Decorative headings

Use Arbutus Slab for decorative headings on marketing pages outside the core product.

A decorative heading is for grabbing attention - don’t use it in text heavy places (such as our privacy policy or contact us pages). Decorative headings should only be used once on the page - usually at the top.



*/
const H = _ref5 => {
  let {
    children,
    ...props
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(StyledH, props, children);
};
var _default = exports.default = H;